export default __webpack_public_path__ + "static/media/secretary.a49bab0d.png";